<template>
    <div v-if="!changeView" class="quote-page fin-relative fin-h-full">
        <el-form class="fin-h-full" :model="authenticationData" ref="formData">
            <div class="fin-relative md:fin-px-6 md:fin-py-24 lg:fin-py-32 lg:fin-px-8 xs:fin-px-5 xs:fin-py-12">

                <h1 class="fin-text-2xl md:fin-text-3xl fin-font-thin fin-leading-snug fin-text-center fin-text-sky-600">
                    Phone Number Verification
                </h1>

                <p class="fin-mx-auto fin-mt-6 fin-max-w-lg fin-text-base md:fin-text-lg fin-text-center fin-text-body xs:fin-max-w-3xl">
                    We've sent a 6-digit code to your mobile ending with
                    <strong>
                        {{ _.get(authReceivingCaller, 'phone').substr(-4) }}
                    </strong>
                </p>

                <p class="fin-mt-3 fin-h-5 fin-flex fin-items-center fin-justify-center">
                    <span :class="[authMessage.error ? 'fin-text-danger' : 'fin-text-success']"
                          v-if="authMessage.message">{{ authMessage.message }}</span>
                </p>

                <div class="fin-mx-auto fin-max-w-xl fin-text-center fin-mt-3">
                    <input
                        v-model="authenticationData.verifyCode"
                        type="number"
                        inputmode="numeric"
                        autocomplete="one-time-code"
                        pattern="\d{6}"
                        maxlength="6"
                        required
                        :autofocus="true"
                        clearable
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        class="fin-w-full md:fin-w-[300px] fin-max-w-full fin-text-lg fin-tracking-widest fin-text-center fin-border fin-rounded fin-border-stroke">
                    </input>
                </div>

                <div class="fin-w-full fin-flex fin-items-center fin-justify-center fin-mt-7">
                    <el-button type="warning" class="fin-btn-lg" @click="resendToken"
                               :loading="resendTokenloading">
                        Resend Token
                    </el-button>
                </div>
            </div>
        </el-form>
    </div>

    <div v-else class="container-fluid fin-h-full xs:fin-px-5">
        <div :class="tenantLogo ? 'fin-space-y-4' : ''">
            <img v-if="tenantLogo" :src="tenantLogo" class="fin-h-10" alt="tenant"/>

            <h2>Video Chat</h2>
        </div>

        <audio hidden id="ringtone" src="/skype_phone.mp3" loop></audio>

        <div class="fin-flex fin-justify-between fin-items-center">
            <div class="fin-my-5 fin-flex fin-items-center fin-space-x-4"
                 v-if="!_.isEmpty(_.get(application, 'applicants'))">
                <div class="fin-flex fin-items-center fin-mt-3">
                    <label class="mr-2">Select Applicant To Call</label>

                    <el-select v-model="selectApplicant" placeholder="Select Applicant" clearable
                               class="filter-item mr-2">
                        <el-option
                            v-for="(applicant, index) in  _.get(application, 'applicants')"
                            :key="index"
                            :label="applicant.full_name"
                            :value="applicant.id"
                        />
                    </el-select>
                </div>

                <el-button
                    class="fin-mt-3"
                    v-if="!_.isEmpty(selectedApplicant) && partnerUrl"
                    type="primary"
                    @click="placeVideoCall"
                    :disabled="calling"
                >
                    Start Video Call
                </el-button>

                <el-button
                    class="fin-mt-3 fin-ml-3"
                    v-if="!_.isEmpty(selectedApplicant) && partnerUrl"
                    type="primary"
                    @click="placeVideoCall(true)"
                    :disabled="calling"
                >
                    Start Video Call Muted
                </el-button>

                <el-button
                    class="fin-mt-3"
                    v-else
                    type="primary"
                    @click="sendLink"
                    :disabled="linkLoading || _.isEmpty(selectedApplicant)"
                    :loading="linkLoading"
                >
                    Send Video Link
                </el-button>
            </div>
            <div v-else class="fin-invisible">
            </div>

            <div
                class="xs:fin-hidden lg:fin-block fin-text-center fin-flex lg:fin-flex-row fin-z-20 fin-items-center"
                v-if="callPlaced">
                <el-button
                    v-if="videoCallParams.peer1"
                    id="blurButton"
                    type="info"
                    @click="blurBackground"
                >
                    {{ isBackgroundBlured ? 'Blur Background' : 'Show Original' }}
                </el-button>

                <el-button
                    v-if="videoCallParams.peer1"
                    type="info"
                    @click="toggleMuteAudio">
                    {{ mutedAudio ? "Unmute" : "Mute" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer2"
                    type="info"
                    @click="toggleMuteRemoteAudio">
                    {{ mutedAudio ? "Unmute" : "Mute" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer1"
                    type="primary"
                    class="fin-mx-2"
                    @click="toggleMuteVideo"
                >
                    {{ mutedVideo ? "Show Video" : "Hide Video" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer2"
                    type="primary"
                    class="fin-mx-2"
                    @click="toggleMuteRemoteVideo"
                >
                    {{ mutedVideo ? "Show Video" : "Hide Video" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.callAccepted && videoCallParams.peer2"
                    :type="!partnerScreenShare ? 'success' : 'warning'"
                    class="fin-mx-2"
                    @click="partnerShareScreen"
                >
                    {{ !partnerScreenShare ? "Share Screen" : "Stop Share Screen" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer1"
                    :type="'primary'"
                    class="fin-mx-2"
                    @click="takeScreenShot"
                >
                    {{ "Screen Shot" }}
                </el-button>
                <el-button type="danger" @click="endCall">
                    End Call
                </el-button>
            </div>
        </div>

        <div class="fin-mt-2 fin-text-center" v-if="!_.isEmpty(brokerMessage) && !_.isEmpty(selectedApplicant)">
            <el-alert
                :title="brokerMessage"
                :type="brokerMessageInfoType">
            </el-alert>
        </div>

        <div class="fin-mt-2 fin-text-center"
             v-if="!_.isEmpty(partnerMessage) && _.isEmpty(_.get(application, 'applicants'))">
            <el-alert
                :title="partnerMessage"
                :type="'info'">
            </el-alert>
        </div>

        <!-- Incoming Call  -->
        <div
            class="fin-my-3 fin-text-center fin-flex fin-flex-col fin-items-center fin-justify-center fin-z-20 fin-my-24"
            v-if="incomingCallDialog">
            <p>
                Incoming Call From <strong>{{ _.get(callerDetails, 'name') }}</strong>
            </p>

            <div class="fin-mt-2 fin-flex fin-space-x-4" role="group">
                <el-button
                    type="danger"
                    data-dismiss="modal"
                    @click="declineCall"
                >
                    Decline
                </el-button>

                <el-button
                    type="success"
                    class="fin-ml-5"
                    @click="acceptCall"
                >
                    Accept
                </el-button>
            </div>
        </div>

        <div class="fin-mt-5 fin-w-full fin-flex fin-flex-col fin-relative"
             id="video-row">
            <div class="partner-video" v-if="!videoCallParams.callAccepted">
                <div v-if="callPartner" class="column items-center q-pt-xl">
                    <div class="col q-gutter-y-md text-center fin-my-2">
                        <p>calling...</p>

                        <p class="q-pt-md">
                            <strong>{{ callPartner }}</strong>
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="lg:fin-w-1/2 fin-h-2/5 xs:fin-w-full fin-relative fin-flex fin-flex-col fin-items-center fin-self-center fin-text-center"
                :class="videoCallParams.callAccepted ? 'fin-mt-0' : 'fin-mt-32'"
                v-if="callPlaced">
                <video
                    ref="userVideo"
                    id="userVideo"
                    muted
                    playsinline
                    autoplay
                    class="cursor-pointer fin-text-center"
                    :class="isFocusMyself === true ? 'lg:fin-w-60 xs:fin-w-40 fin-absolute fin-z-10 lg:fin-top-px xs:fin-top-px fin-left-32' : 'fin-relative fin-inset-0'"
                    :width="isFocusMyself === true ? '240px' : '640px'"
                    :height="isFocusMyself === true ? '180px' : '480px'"
                    v-if="this.peer === 1"
                />

                <video
                    ref="userVideo"
                    id="userVideo"
                    muted
                    playsinline
                    autoplay
                    class="cursor-pointer fin-text-center"
                    :class="isFocusMyself === true ? 'lg:fin-w-60 xs:fin-w-40 fin-absolute fin-z-10 lg:fin-top-px xs:fin-top-px xl:fin-left-14 lg:fin-left-0 xs:fin-left-0 md:fin-left-20' : 'fin-relative fin-inset-0'"
                    :width="isFocusMyself === true ? '240px' : '640px'"
                    :height="isFocusMyself === true ? '180px' : '480px'"
                    v-if="this.peer === 2"
                />

                <div v-if="this.peer === 1" ref="peerCanvas1">
                    <canvas
                        ref="blurCanvas"
                        id="blurCanvas"
                        class="cursor-pointer fin-text-center"
                        :class="isFocusMyself === true ? 'lg:fin-w-60 xs:fin-w-40 fin-absolute fin-z-10 lg:fin-top-px xs:fin-top-px fin-left-32' : 'fin-relative fin-inset-0'"
                    ></canvas>
                </div>

                <div v-if="this.peer === 2" ref="peerCanvas2">
                    <canvas
                        ref="blurCanvas"
                        id="blurCanvas"
                        class="cursor-pointer fin-text-center"
                        :class="isFocusMyself === true ? 'fin-w-full fin-h-1/2 fin-relative fin-inset-0' : 'lg:fin-w-60 xs:fin-w-40 fin-absolute fin-z-10 xs:fin-top-px lg:fin-top-px fin-left-14'"
                    ></canvas>
                </div>

                <video
                    id="partnerVideo"
                    ref="partnerVideo"
                    playsinline
                    autoplay
                    class="fin-text-center"
                    :class="isFocusMyself === true ? 'fin-relative fin-inset-0 fin-h-1/2' : 'lg:fin-w-60 xs:fin-w-40 fin-absolute fin-z-10 xs:fin-top-px lg:fin-top-px fin-left-0'"
                    v-if="videoCallParams.callAccepted"
                    :width="isFocusMyself === true ? '640px' : '240px'"
                    :height="isFocusMyself === true ? '480px' : '180px'"
                />
            </div>

            <div
                class="lg:fin-hidden xs:fin-block fin-grid fin-grid-cols-3 fin-gap-3 fin-mt-4 fin-space-y-2 fin-z-20 fin-text-center fin-absolute fin-inset-x-0 -fin-bottom-14 fin-z-50"
                v-if="callPlaced">
                <el-button
                    v-if="videoCallParams.peer1"
                    type="info"
                    @click="toggleMuteAudio">
                    {{ mutedAudio ? "Unmute" : "Mute" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer2"
                    type="info"
                    @click="toggleMuteRemoteAudio">
                    {{ mutedAudio ? "Unmute" : "Mute" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer1"
                    type="primary"
                    class="fin-mx-2"
                    @click="toggleMuteVideo"
                >
                    {{ mutedVideo ? "Show Video" : "Hide Video" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer2"
                    type="primary"
                    class="fin-mx-2"
                    @click="toggleMuteRemoteVideo"
                >
                    {{ mutedVideo ? "Show Video" : "Hide Video" }}
                </el-button>
                <el-button
                    class="xs:fin-hidden lg:fin-block"
                    v-if="videoCallParams.callAccepted && videoCallParams.peer2"
                    :type="!partnerScreenShare ? 'success' : 'warning'"
                    @click="partnerShareScreen"
                >
                    {{ !partnerScreenShare ? "Share Screen" : "Stop Share Screen" }}
                </el-button>
                <el-button
                    v-if="videoCallParams.peer1"
                    :type="'primary'"
                    @click="takeScreenShot"
                >
                    {{ "Screen Shot" }}
                </el-button>
                <el-button type="danger" @click="endCall">
                    End Call
                </el-button>
            </div>
        </div>

        <div class="fin-my-4 fin-mx-4">
            <canvas ref="captureScreen" :width="'100%'" :height="'100%'"></canvas>
        </div>

        <builder-video-call-modal
            :load-store="!_.isEmpty(this.selectedApplicant)"
            :applicants="applicants"
            :application-id="_.get(application, 'id')"
            :visible.sync="openBuilderVideoCallModal"></builder-video-call-modal>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import Peer from "simple-peer"
import {getPermissions} from "./helpers";
import BuilderVideoCallModal from "./BuilderVideoCallModal";
import "@tensorflow/tfjs-backend-webgl";
import * as tf from '@tensorflow/tfjs';
import {load, drawBokehEffect, BodyPix, toMask} from "@tensorflow-models/body-pix";

export default {
    name: "VideoChat",
    components: {
        BuilderVideoCallModal,
    },
    props: {
        authCheck: {
            required: false,
            default: true
        },
        authuserid: {
            required: false,
            default: Ambition.getGlobal("tenant.userId")
        },
        turn_url: {
            required: false,
            default: Ambition.getGlobal("tenant.turnUrl")
        },
        turn_username: {
            required: false,
            default: Ambition.getGlobal("tenant.turnUsername")
        },
        turn_credential: {
            required: false,
            default: Ambition.getGlobal("tenant.turnCredentials")
        },
        tenant: {
            required: false,
            default: Ambition.getGlobal("tenant.tenantId")
        },
        callFrom: {
            required: false,
        },
        application: {
            required: false,
        },
        userFrom: {
            required: false,
        },
        token: {
            required: false,
        },
        to: {
            required: false,
        },
        authReceivingCaller: {
            required: false,
        },
        login_url: {
            required: false,
        },
        partner_url: {
            required: false,
        },
        tenantLogo: {
            required: false,
        },
        resend_url: {
            required: false,
        }
    },
    data() {
        return {
            openBuilderVideoCallModal: false,
            authenticationData: {
                verifyCode: null,
                verifying: false,
            },
            authMessage: {
                error: false,
                message: null
            },
            triedAndFailed: false,
            changeMobileLoading: false,
            changeMobileForm: {
                newMobileNumber: null
            },
            changeView: false,
            selectApplicant: null,
            selectedApplicant: null,
            servers: {
                iceServers: [
                    {
                        urls: this.turn_url + '?transport=udp',
                        username: this.turn_username,
                        credential: this.turn_credential
                    }
                ],
            },
            PC: null,
            localStream: null,
            remoteStream: null,
            isFocusMyself: true,
            calling: false,
            callPlaced: false,
            callPartner: null,
            mutedAudio: false,
            mutedVideo: false,
            screenShare: false,
            partnerScreenShare: false,
            captureScreen: false,
            senderTrack: null,
            screenStream: null,
            startTime: null,
            interval: null,
            partnerUrl: null,
            linkLoading: false,
            brokerMessage: '',
            brokerMessageInfoType: '',
            partnerMessage: '',
            videoCallParams: {
                users: [],
                stream: null,
                receivingCall: false,
                caller: null,
                callerSignal: null,
                callAccepted: false,
                channel: null,
                blurChannel: null,
                peer1: null,
                peer2: null,
            },
            resendTokenloading: false,
            net: null,
            muted: false,
            mutedRemote: false,
            senderStats: null,
            segmentCanvas: null,
            segmentCtx: null,
            selfieSegmentation: null,
            greenScreen: null,
            FRAME_RATE: 30,
            peer: null,
            toggleButton: null,
            isBackgroundBlured: false,
            peer2VideoElement: null,
            peer2VideoCanvas: null,
        }
    },
    computed: {
        incomingCallDialog() {
            if (
                this.videoCallParams.receivingCall &&
                this.videoCallParams.caller !== this.authuserid
            ) {
                return true;
            }
            return false;
        },
        callerDetails() {
            if (
                this.videoCallParams.caller &&
                this.videoCallParams.caller !== this.authuserid
            ) {
                return {
                    id: this.videoCallParams.caller,
                    name: `${_.get(Ambition.getGlobal('tenant.user'), 'full_name', _.get(this.userFrom, 'full_name'))}`,
                };
            }
            return null;
        },
        applicants() {
            if (this.selectedApplicant) {
                return [this.selectedApplicant]
            } else {
                return []
            }
        }
    },
    watch: {
        'selectApplicant': {
            handler(val) {
                if (val) {
                    this.selectedApplicant = _.find(_.get(this.application, 'applicants'), {id: val})
                }
            },
            deep: true,
            immediate: true
        },
        'authCheck': {
            handler(val) {
                this.changeView = val
            },
            deep: true,
            immediate: true
        },
        'authenticationData.verifyCode': {
            handler(verifyCode) {
                console.warn('verifyCode', verifyCode)
                if (_.size(verifyCode) == 6) {
                    setTimeout(() => {
                        this.authenticationData.verifying = true
                        this.verifyPhoneNumber()
                    }, 200)
                }
            }
        },
        'login_url': {
            handler(val) {
                if (val) {
                    console.log('login_url ', val)
                }
            },
            deep: true,
            immediate: true
        },
        "muted": {
            handler(val) {
                if (val === true) {
                    this.$tenant
                        .post(`/api/video/blur-background`, {
                            from: this.authuserid,
                            data: 'mute'
                        })
                        .then((res) => {
                        })
                        .catch((error) => {
                        });
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.initializeChannel()
        this.initializeCallListeners()

        this.partnerMessage = 'Your call will start shortly'

        const self = this;
        setInterval(() => {
            self.checkState();
            if (self.startTime) {
                self.endTime = new Date().getTime();
            } else {
                self.endTime = null;
            }
        }, 1000);

        getPermissions()

        this.videoCallParams.blurChannel.listen(".background-blur", ({data}) => {
            // peer 2
            if (data == 'blur') {
                if (_.get(this.peer2VideoElement, 'classList') && (this.peer2VideoElement.classList.contains('fin-hidden') || this.peer2VideoElement.classList.contains('fin-invisible'))) {
                    this.peer2VideoElement.classList.remove('fin-hidden');
                    this.peer2VideoElement.classList.remove('fin-invisible');
                    this.peer2VideoElement.classList.add('fin-block');
                } else {
                    if (_.get(this.peer2VideoElement, 'classList')) {
                        this.peer2VideoElement.classList.add('fin-hidden');
                    }
                }

                if (this.peer2VideoElement) {
                    this.peer2VideoElement.play();
                    this.peer2VideoCanvas.parentElement.hidden = !this.peer2VideoCanvas.parentElement.hidden;
                }
            } else if (data == 'mute') {
                this.mutedRemote = true
            }
        });

        let portrait = window.matchMedia("(orientation: portrait)");

        portrait.addEventListener("change", function (e) {
            if (e.matches) {
                // Portrait mode
            } else {
                // Landscape
                let elem = document.getElementById("partnerVideo");
            }
        })
    },
    beforeDestroy() {
        Echo.leave(`call.${this.tenant}.${this.authuserid}`);
        Echo.leave(`blur.${this.tenant}.${this.authuserid}`);
        this.$bus.$off('push-button-two')
    },
    created() {
    },
    methods: {
        blurBackground() {
            this.isBackgroundBlured = !this.isBackgroundBlured;
        },
        resendToken() {
            this.resendTokenloading = true
            this.triedAndFailed = false

            axios
                .post(this.resend_url, {}, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: 'Bearer ' + this.token
                    }
                })
                .then((res) => {
                    if (res.data) {
                        this.resendTokenloading = false
                        this.authMessage = {
                            error: false,
                            message: 'Token Resent'
                        }
                    }
                })
                .catch((err) => {
                    this.resendTokenloading = false
                    console.error(err)
                })
        },
        verifyPhoneNumber() {
            this.authMessage = {
                error: false,
                message: null
            }

            axios
                .post(this.login_url, {token: this.authenticationData.verifyCode})
                .then((res) => {
                    if (res.data) {
                        this.changeView = true
                        this.triedAndFailed = false

                        window.location = this.partner_url
                    }
                })
                .catch((err) => {
                    this.triedAndFailed = true
                    this.authMessage = {
                        message: 'Verification failed, please try again...',
                        error: true
                    }
                })
                .finally(() => {
                    this.authenticationData.verifying = false
                })
        },
        async takeScreenShot() {
            const track = this.$refs.partnerVideo.srcObject.getVideoTracks()[0]

            const imageCapture = new ImageCapture(track)

            const bitmap = await imageCapture.grabFrame()

            const canvas = this.$refs.captureScreen

            canvas.width = _.get(bitmap, 'width')
            canvas.height = _.get(bitmap, 'height')

            canvas.getContext("bitmaprenderer").transferFromImageBitmap(bitmap);
            const blob = await new Promise((res) => canvas.toBlob(res));

            this.captureScreen = true

            if (this.videoCallParams.peer1) {
                await this.uploadScreenShot()
            } else {
                await this.partnerUploadScreenShot()
            }
        },
        dataURLToBlob(dataURL) {
            var parts = dataURL.split(";base64,")
            var contentType = parts[0].split(":")[1]
            var raw = window.atob(parts[1])
            var rawLength = raw.length
            var uInt8Array = new Uint8Array(rawLength)

            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
            }

            return new Blob([uInt8Array], {type: contentType})
        },
        download(dataURL) {
            let blob = this.dataURLToBlob(dataURL)
            return blob
        },
        uploadScreenShot() {
            const canvas = this.$refs.captureScreen

            let dataURL = canvas.toDataURL("image/png")

            const formData = new FormData()
            formData.append("screenShot", dataURL)
            formData.append("tenant", this.tenant)
            formData.append("screenShotSize", _.get(this.download(dataURL), 'size'))
            formData.append("fileName", `video_screen_shot_${this.authuserid}_${_.get(this.selectedApplicant, 'id', this.to)}_${this.$moment()}.png`)
            formData.append("applicant", `${_.get(this.selectedApplicant, 'id', this.to)}`)
            formData.append("uploader_name", `${_.get(Ambition.getGlobal('tenant.user'), 'full_name', _.get(this.userFrom, 'full_name'))}`)
            formData.append("uploader_id", `${_.get(Ambition.getGlobal('tenant.user'), 'id', _.get(this.userFrom, 'id'))}`)

            axios.post(`/api/video/upload-screen-shot/${_.get(this.application, 'id')}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: 'Bearer ' + this.$store.getters.token
                }
            }).then((res) => {
                swal({
                    title: "Success",
                    type: "success",
                    text: "Screen Shot Uploaded To Documents!!"
                })
            }).catch((err) => {
                swal({
                    title: "Error",
                    type: "error",
                    text: "Error Uploading Screen Shot !!"
                })
            })
        },
        async partnerUploadScreenShot() {
            const canvas = this.$refs.captureScreen

            let dataURL = canvas.toDataURL("image/png")

            const formData = new FormData()
            formData.append("screenShot", dataURL)
            formData.append("tenant", this.tenant)
            formData.append("screenShotSize", _.get(this.download(dataURL), 'size'))
            formData.append("fileName", `video_screen_shot_${this.authuserid}_${_.get(this.selectedApplicant, 'id', this.to)}.png`)
            formData.append("applicant", `${_.get(this.selectedApplicant, 'id', this.to)}_${this.$moment()}`)
            formData.append("uploader_name", `${_.get(Ambition.getGlobal('tenant.user'), 'full_name', _.get(this.userFrom, 'full_name'))}`)
            formData.append("uploader_id", `${_.get(Ambition.getGlobal('tenant.user'), 'id', _.get(this.userFrom, 'id'))}`)

            await axios.post(`/api/video/upload-screen-shot/${_.get(this.application, 'id')}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: 'Bearer ' + this.token
                }
            }).then((res) => {
                swal({
                    title: "Success",
                    type: "success",
                    text: "Screen Shot Uploaded!!"
                })
            }).catch((err) => {
                swal({
                    title: "Error",
                    type: "error",
                    text: "Error Uploading Screen Shot !!"
                })
            })
        },
        initializeChannel() {
            this.videoCallParams.channel = Echo.join(`call.${this.tenant}.${this.authuserid}`);
            this.videoCallParams.blurChannel = Echo.join(`blur.${this.tenant}.${this.authuserid}`);
        },
        async getMediaPermission(peer = null) {
            this.peer = peer

            return getPermissions()
                .then(async (stream) => {
                        this.videoCallParams.stream = stream;
                        if (this.$refs.userVideo) {
                            this.$refs.userVideo.srcObject = stream;
                            if (peer === 1) {
                                let videoElement = this.$refs.userVideo
                                videoElement.classList.add('fin-invisible');
                                videoElement.play();

                                videoElement.addEventListener("loadeddata", async () => {
                                    let transparentCanvas = document.getElementById('blurCanvas');

                                    // this.renderFrame(videoElement, transparentCanvas, ctx)
                                    const net = await load({
                                        architecture: "MobileNetV1",
                                        outputStride: 16,
                                        multiplier: 0.75,
                                        quantBytes: 2
                                    })

                                    this.loop(transparentCanvas, videoElement, net)

                                    document.querySelector('#blurButton').onclick = () => {
                                        if (videoElement.classList.contains('fin-hidden') || videoElement.classList.contains('fin-invisible')) {
                                            videoElement.classList.remove('fin-hidden');
                                            videoElement.classList.remove('fin-invisible');
                                            videoElement.classList.add('fin-block');
                                        } else {
                                            videoElement.classList.add('fin-hidden');
                                        }
                                        videoElement.play();

                                        transparentCanvas.parentElement.hidden = !transparentCanvas.parentElement.hidden;

                                        this.$tenant
                                            .post(`/api/video/blur-background`, {
                                                from: this.authuserid,
                                                data: 'blur'
                                            })
                                            .then((res) => {
                                            })
                                            .catch((error) => {
                                            });
                                    };
                                });
                            } else if (peer === 2) {
                                let videoElement = this.$refs.partnerVideo
                                this.peer2VideoElement = this.$refs.partnerVideo
                                videoElement.classList.add('fin-hidden');
                                videoElement.play();

                                let transparentCanvas = document.getElementById('blurCanvas');
                                videoElement.addEventListener("loadeddata", async () => {
                                        const net = await load({
                                            architecture: "MobileNetV1",
                                            outputStride: 16,
                                            multiplier: 0.75,
                                            quantBytes: 4
                                        })

                                        this.loopPeer2(transparentCanvas, videoElement, net)
                                    }
                                );

                                this.peer2VideoCanvas = transparentCanvas
                            }
                        }
                    }
                )
                .catch((error) => {
                    console.log(error);
                });
        },
        async loop(canvas, video, net) {
            // Request the next animation frame
            requestAnimationFrame(() => {
                this.loop(canvas, video, net)
            })

            const personSegmentation = await net.segmentPerson(video, {
                internalResolution: 'medium'
            });

            const backgroundBlurAmount = 6;
            const edgeBlurAmount = 6;
            const flipHorizontal = false;

            // draw the image with the background blurred onto the canvas. The edge between the person and blurred background is blurred by 3 pixels.
            drawBokehEffect(canvas, video, personSegmentation, backgroundBlurAmount, edgeBlurAmount, flipHorizontal);
        },
        async loopPeer2(canvas, video, net) {
            // Request the next animation frame
            requestAnimationFrame(() => {
                this.loop(canvas, video, net)
            })

            const personSegmentation = await net.segmentPerson(video, {
                internalResolution: 'full'
            });

            const backgroundBlurAmount = 10;
            const edgeBlurAmount = 10;
            const flipHorizontal = false;

            // draw the image with the background blurred onto the canvas. The edge between the person and blurred background is blurred by 3 pixels.
            drawBokehEffect(canvas, video, personSegmentation, backgroundBlurAmount, edgeBlurAmount, flipHorizontal);
        },
        async shareScreen() {
            if (this.screenShare) {
                this.stopSharing()
            } else {
                navigator.mediaDevices.getDisplayMedia({video: {cursor: 'always'}, audio: false}).then(stream => {
                    this.screenStream = stream;
                    const videoTrack = stream.getVideoTracks()[0];

                    let pc = _.get(this.videoCallParams.peer1, '_pc')

                    let sender = pc.getSenders().find(function (s) {
                        return s.track.kind == videoTrack.kind;
                    })

                    sender.replaceTrack(videoTrack)
                    this.$refs.userVideo.srcObject.getVideoTracks()[0] = videoTrack
                    this.screenShare = true

                    videoTrack.onended = function () {
                        this.stopSharing()
                    }
                })
            }
        },
        stopSharing() {
            let pc = _.get(this.videoCallParams.peer1, '_pc')
            let localTrack = this.videoCallParams.stream.getVideoTracks()[0]

            let sender = pc.getSenders().find(function (s) {
                return s.track.kind == localTrack.kind;
            })

            sender.replaceTrack(localTrack)
            this.screenShare = false
            this.$refs.userVideo.srcObject.getVideoTracks()[0] = localTrack

            if (this.screenStream) {
                this.screenStream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }
        },
        async partnerShareScreen() {
            if (this.partnerScreenShare) {
                this.partnerStopSharing()
            } else {
                navigator.mediaDevices.getDisplayMedia({video: {cursor: 'always'}, audio: false})
                    .then(stream => {
                        this.screenStream = stream;
                        const videoTrack = stream.getVideoTracks()[0];

                        let pc = _.get(this.videoCallParams.peer2, '_pc')

                        let sender = pc.getSenders().find(function (s) {
                            return s.track.kind == videoTrack.kind;
                        })

                        sender.replaceTrack(videoTrack)
                        this.videoCallParams.stream.getVideoTracks()[0] = videoTrack
                        this.partnerScreenShare = true

                        stream.getVideoTracks()[0].addEventListener('ended', () => {
                            console.log('The user has ended sharing the screen');
                            this.partnerStopSharing()
                        });
                    })
            }
        },
        partnerStopSharing() {
            let pc = _.get(this.videoCallParams.peer2, '_pc')
            let localTrack = this.videoCallParams.stream.getVideoTracks()[0]

            let sender = pc.getSenders().find(function (s) {
                return s.track.kind == localTrack.kind;
            })

            sender.replaceTrack(localTrack)
            this.partnerScreenShare = false
            this.videoCallParams.stream.getVideoTracks()[0] = localTrack

            if (this.screenStream) {
                this.screenStream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }
        },
        initializeCallListeners() {
            this.videoCallParams.channel.here((users) => {
                this.videoCallParams.users = users;
            });
            this.videoCallParams.channel.joining((user) => {
                if (_.get(this.selectedApplicant, 'full_name')) {
                    this.brokerMessageInfoType = 'success'
                    this.brokerMessage = _.get(this.selectedApplicant, 'full_name') + ' is now ready for you call, please click the Start Video Call button above.'
                } else {
                    this.brokerMessageInfoType = ''
                    this.brokerMessage = null
                }
                // check user availability
                const joiningUserIndex = this.videoCallParams.users.findIndex(
                    (data) => data.id === user.id
                );
                if (joiningUserIndex < 0) {
                    this.videoCallParams.users.push(user);
                }
            });
            this.videoCallParams.channel.leaving((user) => {
                const leavingUserIndex = this.videoCallParams.users.findIndex(
                    (data) => data.id === user.id
                );
                this.videoCallParams.users.splice(leavingUserIndex, 1);
            });

            // listen to incoming call
            this.videoCallParams.channel.listen(".video-chat", ({data}) => {
                if (data.type === "incomingCall") {
                    // add a new line to the sdp to take care of error
                    const updatedSignal = {
                        ...data.signalData,
                        sdp: `${data.signalData.sdp}\n`,
                    };
                    this.videoCallParams.receivingCall = true;
                    this.videoCallParams.caller = data.from;
                    this.videoCallParams.callerSignal = updatedSignal;
                    this.partnerMessage = ''
                }
            });
        },
        sendLink() {
            this.openBuilderVideoCallModal = true

            this.linkLoading = true

            this.$tenant
                .post(`/api/video/send-link/${_.get(this.application, 'id')}`, {
                    to: _.get(this.selectedApplicant, 'id')
                })
                .then((res) => {
                    this.linkLoading = false
                    this.partnerUrl = _.get(res.data, 'partnerUrl')
                    this.brokerMessage = _.get(res.data, 'message')
                    this.brokerMessageInfoType = _.get(res.data, 'status')
                })
                .catch((error) => {
                    console.log(error);
                    this.linkLoading = false
                });
        },
        async placeVideoCall(mute = false) {
            this.muted = mute

            this.callPlaced = true;
            this.callPartner = _.get(this.selectedApplicant, 'full_name');
            await this.getMediaPermission(1);

            if (mute === true) {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = false;
                this.mutedAudio = true;
            } else {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = true;
                this.mutedAudio = false;
            }

            this.videoCallParams.peer1 = new Peer({
                initiator: true,
                trickle: false,
                stream: this.videoCallParams.stream,
                config: {
                    ...this.servers
                },
            });

            this.PC = _.get(this.videoCallParams.peer1, '_pc')

            // Pull tracks from remote stream, add to video stream
            this.videoCallParams.peer1.on("signal", (data) => {
                // send user call signal
                this.calling = true
                this.$tenant
                    .post(`/api/video/call-user`, {
                        user_to_call: _.get(this.selectedApplicant, 'full_name'),
                        signal_data: data,
                        from: this.authuserid,
                        to: _.get(this.selectedApplicant, 'id'),
                        applicationId: _.get(this.application, 'id')
                    })
                    .then((res) => {
                        this.calling = false
                        this.brokerMessageInfoType = ''
                        this.brokerMessage = ''
                    })
                    .catch((error) => {
                        console.log(error);
                        this.calling = false
                    });
            });

            this.videoCallParams.peer1.on("stream", (stream) => {
                console.log("call streaming");
                if (this.$refs.partnerVideo) {
                    this.$refs.partnerVideo.srcObject = stream;
                }
            });

            this.videoCallParams.peer1.on("connect", () => {
                console.log("peer connected");
            });
            this.videoCallParams.peer1.on("error", (err) => {
                console.log(err);
            });
            this.videoCallParams.peer1.on("close", () => {
                console.log("call closed caller");
                this.videoCallParams.peer1.restartIce()
            });

            this.videoCallParams.channel.listen(".video-chat", ({data}) => {
                if (data.type === "callAccepted") {
                    if (data.signal.renegotiate) {
                        console.log("renegotating");
                    }
                    if (data.signal.sdp) {
                        this.videoCallParams.callAccepted = true;
                        const updatedSignal = {
                            ...data.signal,
                            sdp: `${data.signal.sdp}\n`,
                        };
                        this.videoCallParams.peer1.signal(updatedSignal);
                    }
                }
            });
        },
        checkState() {
            if (this.PC) {
                this.PC.onconnectionstatechange = function (d) {
                    console.log("onconnectionstatechange", d);
                    switch (_.get(this.PC, 'iceConnectionState')) {
                        case "connected":
                            if (!this.startTime) {
                                this.startTime = new Date().getTime();
                            }

                            break;
                        case "failed":
                        case "disconnected":
                            this.restart();
                            break;
                    }
                };
                this.PC.onsignalingstatechange = function (d) {
                    switch (_.get(this.PC, 'signalingState')) {
                        case "closed":
                            this.endCall(true);
                            if (this.interval) {
                                clearInterval(this.interval);
                            }
                            this.endCall(true);

                            break;
                    }
                };
            }
        },
        async acceptCall() {
            this.callPlaced = true;
            this.videoCallParams.callAccepted = true;
            await this.getMediaPermission(2);
            this.videoCallParams.peer2 = new Peer({
                initiator: false,
                trickle: false,
                stream: this.videoCallParams.stream,
                config: {
                    iceServers: [
                        {
                            urls: this.turn_url,
                            username: this.turn_username,
                            credential: this.turn_credential,
                        },
                    ],
                },
            });

            this.videoCallParams.receivingCall = false;

            this.videoCallParams.peer2.on("signal", (data) => {
                axios.post("/api/video/accept-user", {
                    signal: data,
                    to: this.videoCallParams.caller,
                    tenant: this.tenant,
                    fromId: _.get(this.userFrom, 'id'),
                    applicationId: _.get(this.application, 'id'),
                    userFrom: this.userFrom,
                    userTo: this.to
                }, {
                    headers: {Authorization: 'Bearer ' + this.token}
                })
                    .then((res) => {
                        this.brokerMessage = ''
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });

            this.videoCallParams.peer2.on("stream", (stream) => {
                this.videoCallParams.callAccepted = true;
                this.$refs.partnerVideo.srcObject = stream;

                // if (this.mutedRemote) {
                //     this.videoCallParams.stream.getAudioTracks()[0].enabled = false;
                //     this.mutedAudio = true;
                // } else {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = true;
                this.mutedAudio = false;
                // }
            });

            this.videoCallParams.peer2.on("connect", () => {
                console.log("peer connected");
                this.videoCallParams.callAccepted = true;
            });

            this.videoCallParams.peer2.on("error", (err) => {
                console.log(err);
                this.videoCallParams.peer2.restartIce()
            });

            this.videoCallParams.peer2.on("close", () => {
                console.log("call closed accepter");
            });

            this.videoCallParams.peer2.on("background change", () => {
                console.log("background change");
            });

            this.videoCallParams.peer2.signal(this.videoCallParams.callerSignal);
        },
        toggleCameraArea() {
            if (this.videoCallParams.callAccepted) {
                this.isFocusMyself = !this.isFocusMyself;
            }
        },
        declineCall() {
            this.videoCallParams.receivingCall = false;
        },
        toggleMuteAudio() {
            if (this.mutedAudio) {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = true;
                this.mutedAudio = false;
            } else {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = false;
                this.mutedAudio = true;
            }
        },
        toggleMuteRemoteAudio() {
            if (this.mutedAudio) {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = true;
                this.mutedAudio = false;
            } else {
                this.videoCallParams.stream.getAudioTracks()[0].enabled = false;
                this.mutedAudio = true;
            }
        },
        toggleMuteVideo() {
            if (this.mutedVideo) {
                this.videoCallParams.stream.getVideoTracks()[0].enabled = true;
                this.mutedVideo = false;
            } else {
                this.videoCallParams.stream.getVideoTracks()[0].enabled = false;
                this.mutedVideo = true;
            }
        },
        toggleMuteRemoteVideo() {
            if (this.mutedVideo) {
                this.videoCallParams.stream.getVideoTracks()[0].enabled = true;
                this.mutedVideo = false;
            } else {
                this.videoCallParams.stream.getVideoTracks()[0].enabled = false;
                this.mutedVideo = true;
            }
        },
        stopStreamedVideo(videoElem) {
            const stream = videoElem.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach((track) => {
                track.stop();
            });
            videoElem.srcObject = null;
        },
        async restart() {
            const offerDescription = await this.PC.createOffer({iceRestart: true});
            await this.PC.setLocalDescription(offerDescription);

            this.$tenant
                .post(`/api/video/call-user`, {
                    user_to_call: _.get(this.selectedApplicant, 'full_name'),
                    signal_data: offerDescription,
                    from: this.authuserid,
                    to: _.get(this.selectedApplicant, 'id'),
                    applicationId: _.get(this.application, 'id')
                })
                .then(() => {
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        endCall() {
            // if video or audio is muted, enable it so that the stopStreamedVideo method will work
            if (!this.mutedVideo) this.toggleMuteVideo();
            if (!this.mutedAudio) this.toggleMuteAudio();

            this.stopStreamedVideo(this.$refs.userVideo);

            if (this.videoCallParams.peer1) {
                axios.post("/api/video/end-call", {
                    to: this.videoCallParams.caller,
                    tenant: this.tenant,
                    fromId: _.get(this.userFrom, 'id'),
                    applicationId: _.get(this.application, 'id'),
                    userFrom: this.userFrom,
                    userToName: _.get(this.selectedApplicant, 'full_name'),
                }, {
                    headers: {Authorization: 'Bearer ' + _.get(this.$store.getters, 'token', this.token)}
                })
                    .then((res) => {
                        this.selectedApplicant = null
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }

            if (this.authuserid === this.videoCallParams.caller) {
                this.videoCallParams.peer1.destroy();
            } else {
                this.videoCallParams.peer2.destroy();
            }

            clearInterval(this.interval);

            this.videoCallParams.channel.pusher.channels.channels[
                `presence-call.${this.tenant}.${this.authuserid}`
                ].disconnect();
            setTimeout(() => {
                this.callPlaced = false;
                this.callPartner = null;
            }, 3000);
        }
    }
}
</script>

<style scoped>
#video-row {
}

.video-container {
    width: 700px;
    height: 500px;
    max-width: 90vw;
    max-height: 50vh;
    margin: 0 auto;
    position: relative;
    box-shadow: 1px 1px 11px #9e9e9e;
    background-color: #fff;
    align-self: center;
}

.video-container .user-video {
    width: 30%;
    position: absolute;
    left: 10px;
    bottom: 10px;
    border: 1px solid #fff;
    border-radius: 6px;
    z-index: 2;
}

.video-container .partner-video {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1;
    margin: 0;
    padding: 0;
}

.video-container .action-btns {
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -50px;
    z-index: 3;
    display: flex;
    flex-direction: row;
}

/* Mobiel Styles */
@media only screen and (max-width: 768px) {
    .video-container {
        height: 50vh;
    }
}
</style>
